<mat-form-field class="{{ mergedOptions.class }}">
    <mat-label>{{ mergedOptions.label | translate }}</mat-label>
    <mat-select id="{{idPrefix}}input_select{{idSuffix}}"
                [(ngModel)]="selectedId"
                (ngModelChange)="onSelectionChange()"
                [disabled]="disabled">
        <mat-option id="{{idPrefix}}input_select{{idSuffix}}.item_empty" *ngIf="mergedOptions.optional" [value]="null">{{ 'common.label.none' | translate }}</mat-option>
        <mat-option *ngFor="let item of list; let idx = index" [value]="item.id"
                    id="{{idPrefix}}input_select{{idSuffix}}.item_{{idx}}">
            {{ item.displayName | translate }}
        </mat-option>
    </mat-select>
</mat-form-field>
